export default navigator && /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
